import { Icon } from './Icon';
import './Pager.css';

// Round numbered pagination. `onHover` lets the page prefetch the target's posters.
export function Pager({ page, pages, from, to, total, onChange, onHover }) {
    if (pages <= 1) return null;
    const numbers = Array.from({ length: pages }, (_, i) => i + 1);

    return (
        <nav className="pagerWrap" aria-label="Template pages">
            <div className="pager glass">
                <button type="button" className="pagerArrow" onClick={() => onChange(page - 1)} disabled={page <= 1} aria-label="Previous page">
                    <Icon name="chevLeft" size={18} />
                </button>
                {numbers.map((n) => (
                    <button
                        key={n}
                        type="button"
                        className={`pagerNum${n === page ? ' pagerNum--active' : ''}`}
                        onClick={() => onChange(n)}
                        onPointerEnter={() => onHover?.(n)}
                        aria-current={n === page ? 'page' : undefined}
                        aria-label={`Page ${n}`}
                    >
                        {n}
                    </button>
                ))}
                <button type="button" className="pagerArrow" onClick={() => onChange(page + 1)} disabled={page >= pages} aria-label="Next page">
                    <Icon name="chevRight" size={18} />
                </button>
            </div>
            <div className="pagerCaption">{from}–{to} of {total}</div>
        </nav>
    );
}
